






























































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { logoutPanel } from "@/components"
import productList from "./productList.vue"
import productDetail from "./productDetail.vue"
import memeberList from "./memeberList.vue"
import settlementDesk from "./settlementDesk.vue"
import selectMember from "./selectMember.vue"
import noCodeProduct from "./noCodeProduct.vue"
import leftProductDetail from "./leftProductDetail.vue"
import remarkPanel from "./remarkPanel.vue"
import changePricePanel from "./changePricePanel.vue"
import changeSpecANum from "./changeSpecANum.vue"
import mulChangePricePanel from "./mulChangePricePanel.vue"
import { TbCoupon, TbGoods,TbMember,TbOrderPad,TbSettingsPad } from '@/http';
import { fmoney } from '@/common/money';
import calculate from '@/common/util/calculate';
import dayjs from 'dayjs';
import Bus from '@/common/util/bus';
import { Dialog, Toast } from 'vant';
const { userAgent } = navigator;
  const isAndroid =
    userAgent.indexOf("Android") > -1 ||
    userAgent.indexOf("android") > -1 ||
    userAgent.indexOf("Adr") > -1; // android终端
@Component({
    components: {
        logoutPanel,productList,productDetail,memeberList,settlementDesk,selectMember,noCodeProduct,leftProductDetail,remarkPanel,changePricePanel,
        changeSpecANum,mulChangePricePanel
    },
})
export default class cashierOperate extends Vue {
    public $refs: {
        barcode:HTMLFormElement;
    };
    fmoney = fmoney;

    /**购物车列表 */
    gwList=[];
    /**结算页-购物车列表 */
    gwListByCalc=[];

    /**提示弹窗 */
    tipShow = false;
    tipTitle ="";
    tipText="";
    confirmText="";
    cancelText="";
    btnNums=1;
    tipType=1;

    /**历史挂单数据 */
    historyGdList:any=[];

    /**右侧模块展示内容 */
    /**
     * 1:商品模块
     * 2：会员模块
     * 3：收银模块
      */
    showType = 1;

    /**系统配置 */
    settingContent:any={};
    /**是否允许负库存 */
    isZeroStock=null;

    userInfo:any={};

    /**会员信息 */
    memberInfo:any={};

    /**长按删除相关 */
    Loop=null;
    deleteIndex=null;

    /**选择会员相关 */
    selectMemberShow = false;

    /**无码商品相关 */
    nocodeShow = false;

    /**后台返回计算信息 */
    calcOrderInfo:any = {};

    /**小计相关 */
    /**数量 */
    get numTotal(){
        let val = 0;
        let arr=this.gwList.filter(v=>v.num).map(v=>v.num);
        if(arr.length>0){
            val = arr.reduce((a,b)=>calculate.addition(Number(a),Number(b)))
        }
        return val;
    }
    /**钱 */
    get priceTotal(){
        let val = 0;
        let arr=this.gwList.filter(v=>v.finalPrice).map(v=>calculate.multiplication(v.finalPrice,v.num));
        if(arr.length>0){
            val = arr.reduce((a,b)=>calculate.addition(Number(a),Number(b)))
        }
        return val;
    }
    get originPriceTotal(){
        let val = 0;
        let arr=this.gwList.filter(v=>v.sellingPrice).map(v=>calculate.multiplication(v.sellingPrice,v.num));
        if(arr.length>0){
            val = arr.reduce((a,b)=>calculate.addition(Number(a),Number(b)))
        }
        return val;
    }
    get isChanging(){
        let val = false;
        val = this.$refs['changePricePanel'].show||this.$refs['changeSpecANum'].show||this.$refs['mulChangePricePanel'].show;
        return val;
    }

    /**结算台带来的信息 */
    sdObj:any = {
        memberCouponId:"",
        isSingle:false,
        isWholeOrderDiscount:false,
        wholeOrderDiscountPrice:0,
        orderDiscount:0,
        isDeduction:false,
        useIntegral:0,
        pointDeduction:0,
    };
    /**赠品数量 */
    get giftNum(){
        let val=0;
        let arr = this.gwList.filter(v=>v.isGift).map(v=>v.num);
        if(arr.length>0){
            val = arr.reduce((a,b)=>calculate.addition(a,b))
        }
        return val;
    }
    /**是否是取单模块 */
    isQd=false;

    /**编辑弹窗-索引 */
    editIndex=null;
    editForm:any={isGift:false};

    /**扫描优惠券弹窗是否打开 */
    isCouponShow = false;

    /**收银-支付弹窗是否打开 */
    isPaying = false;

    isScaning = false;
    scanItem:any={};

    payingVal="";
    payingTimeOut = null;

    /**会员姓名八位 */
    get formatMemberName(){
        let str = "";
        if(this.memberInfo.name){
            str = this.memberInfo.name.length>8?this.memberInfo.name.slice(0,8)+'...':this.memberInfo.name;
        }
        return str;
    }
    /**批量改价是否禁用 */
    get mulChangeDisable(){
        let val = false;
        if(this.gwList.length>0&&this.gwList.filter(v=>v.isGift||v.isNoCode).length==this.gwList.length){
            val = true;
        }
        return val;
    }
    created() {
    }
    async mounted() {

        // setTimeout(()=>{
        //     this.testFun()
        // },15000)
        localStorage.removeItem("orderRemark")
        window.onload = ()=>{
            console.log('onload');
            document.addEventListener('click',this.chargeInputFocus)

        }
        this.userInfo = JSON.parse(localStorage.getItem('padUserinfo'));
        this.historyGdList = localStorage.getItem('historyGdList')?JSON.parse(localStorage.getItem('historyGdList')):[];
        this.getSetting();
        /**扫码-app输入框聚焦 */

        Bus.$on('isScaning',(val)=>{
            this.isScaning = val;
            this.$nextTick(()=>{
                this.getInputFocus()
                document.addEventListener('click',this.chargeInputFocus)
            })
        })

        // 优惠券扫码
        Bus.$on('watchCouponScan',async (val)=>{
            this.isCouponShow = val;
            this.$nextTick(()=>{
                this.getInputFocus()
                document.addEventListener('click',this.chargeInputFocus)
            })

        })
        // 支付扫码
        Bus.$on('isPaying',async (val)=>{
            this.isPaying = val;
            this.$nextTick(()=>{
                this.getInputFocus()
                document.addEventListener('click',this.chargeInputFocus)
            })
        })

            this.getInputFocus()
            document.addEventListener('click',this.chargeInputFocus)


    }
    async getInputFocus(){
        this.scanCodes = "";
        this.$nextTick(()=>{
            this.$refs['barcode'].focus()
            document.addEventListener('keydown', this.handleScanCode)
        })
    }
    chargeInputFocus(event){
        if (event.target.tagName.toLowerCase() != 'input'&&event.target.tagName.toLowerCase() != 'textarea') {
            this.getInputFocus()
        }
    }

    beforeDestroy() {
        document.removeEventListener('keydown',this.handleScanCode) //离开当前路由，会直接调用beforeDestroy方法销毁回车事件
        document.removeEventListener('click', this.chargeInputFocus)
        localStorage.removeItem("gwByCoupon");
        localStorage.removeItem("receivablesByCoupon");
        Bus.$off('isScaning');
        Bus.$off('watchCouponScan');
        Bus.$off('isPaying');
        Bus.$off('resultPayCode');
        Bus.$off('returnScanCouponResult');
        Bus.$off('payFalse');
    }
    public scanCodes:any = ''
   /**
     * 监听扫码枪输入
     */
    async handleScanCode(event) {
        if(event.target.nodeName=='TEXTAREA') return;
        if (event.key === 'Backspace' || event.keyCode === 8) {
        // 允许退格键的默认行为
        return;
        }
        console.log('code',event.key,event.keyCode,event.target.value,event)
        if (event.key === 'Enter' || event.keyCode == 13||event.code==='Enter') {
            let code = event.target.value?event.target.value:this.scanCodes
            this.scanInput(code)
            this.scanCodes = ''
            return
        }
    }

    async scanInput(val){
        if(this.isScaning) return;
        if(val){
            /**扫描的会员码 */
            let memberIndex = val.indexOf('HY');
            if(memberIndex>-1){
                if(this.showType==3) return;
                let shopInfo = JSON.parse(localStorage.getItem('padShopInfo'));
                let phone = calculate.subtraction(val.slice(2),shopInfo.shopNo);
                if(phone>0){
                    let memberInfo = await TbMember.GetTbMemberList({
                        key:phone,
                        skip:0,
                        count:-1
                    });

                    if(memberInfo.items.length>0){
                        this.chooseMember(memberInfo.items[0]);
                    }
                }
            }else{
                /**扫优惠券 */
                if(this.isCouponShow){
                    // Toast('isCouponShow'+','+val);
                    let defaultArr=this.gwListByCalc;
                    let gwList = localStorage.getItem("gwByCoupon")?JSON.parse(localStorage.getItem("gwByCoupon")):defaultArr;
                    if(!localStorage.getItem("gwByCoupon")){
                        localStorage.setItem('gwByCoupon',JSON.stringify(defaultArr));
                    }
                    let res = await TbCoupon.GetSettlementCouponList({
                        memberCouponCode:val,
                        memberId:this.memberInfo.id,
                        goodsList:gwList.map(v=>{
                            return{
                                goodsId:v.id,
                                articleNo:v.articleNo,
                                goodsPrice:v.finalPrice,
                                isOriginal:v.isOriginal,
                                quantity:v.num
                            }
                        })
                    })
                    if(res.availableList.length>0){
                        let obj = Object.assign({},res.availableList[0],{canUse:true})
                        Bus.$emit('returnScanCouponResult',obj);
                    }else if(res.notAvailableList.length>0){
                        let obj = Object.assign({},res.notAvailableList[0],{canUse:false})
                        Bus.$emit('returnScanCouponResult',obj);
                    }else{
                        Bus.$emit('returnScanCouponResult',null);

                    }


                }else if(this.isPaying){
                    if(this.payingVal&&this.payingVal==val) return;
                    clearTimeout(this.payingTimeOut);
                    this.payingVal = val;
                    Bus.$emit('resultPayCode',val);
                    this.payingTimeOut= setTimeout(()=>{
                        this.payingVal = "";
                    },5000)
                } else{
                    if(this.showType!=3){
                        /**扫商品 */
                        try {
                            let resnew = await TbGoods.GetTbGoodsByBarCodeV3({barCode:val});
                            if(resnew.items.length>1) {
                                console.log('有类似');
                                this.$refs['productlist'].giveProduct(resnew.items);
                                return;
                            }
                            let res = resnew.items[0];
                            if(res.getGoodsItemsList&&res.getGoodsItemsList.length>0){
                                if(res.isDelete){
                                    this.tipTitle = "无效条形码";
                                    this.tipText = `商品不存在或已删除!`;
                                    this.btnNums=1;
                                    this.confirmText = "确认";
                                    this.cancelText = ""
                                    this.tipType = 13;
                                    this.tipShow = true;
                                    return;
                                }else{
                                    if(res.getGoodsItemsList&&res.getGoodsItemsList.length>0){
                                        let selectItem = res.getGoodsItemsList.filter(v=>v.barCode==res.barCode);
                                        let indexArr = this.gwList.filter(j=>j.goodsItemId==selectItem[0].id);
                                        let isGift = false;
                                        if(indexArr.length==0){
                                            isGift = false;
                                        }else if(indexArr.length==1){
                                            isGift = indexArr[0].isGift
                                        }else if(indexArr.length==2){
                                            isGift = false
                                        }
                                        let obj = Object.assign({},res,{addGoodsItemsList:selectItem},{num:1,isGift:isGift,isEdit:false});
                                        if(!res.isShelves){
                                            this.tipTitle = "商品已下架";
                                            this.tipText = `该商品已下架，确定将该商品添加至购物车中吗？`;
                                            this.btnNums=2;
                                            this.confirmText = "确认";
                                            this.cancelText = "取消"
                                            this.tipType = 14;
                                            this.tipShow = true;
                                            this.scanItem = obj;
                                            return;
                                        }
                                        if(!this.isZeroStock&&selectItem[0].stock<=0){
                                            let index = this.gwList.findIndex(j=>j.goodsItemId==selectItem[0].id&&(j.isGift==res.isGift));
                                            if(index>-1){
                                                this.addProduct(obj);
                                                return;
                                            }else{
                                                this.tipTitle = "无库存商品";
                                                this.tipText = `该商品无库存，确定将该商品添加至购物车中吗？`;
                                                this.btnNums=2;
                                                this.confirmText = "确认";
                                                this.cancelText = "取消"
                                                this.tipType = 15;
                                                this.tipShow = true;
                                                this.scanItem = obj;
                                                return;
                                            }
                                        }
                                        this.addProduct(obj);
                                    }
                                }

                            }else{
                                this.tipTitle = "无效条形码";
                                this.tipText = `请扫描使用本收银系统生成的商品标签上的条形码!`;
                                this.btnNums=1;
                                this.confirmText = "确认";
                                this.cancelText = ""
                                this.tipType = 16;
                                this.tipShow = true;
                            }

                        } catch (error) {

                        }
                    }

                }
            }
        }
    }

    async testFun(){
        // let res = await TbCoupon.GetSettlementCouponList({
        //     memberCouponCode:'703458Zh',
        //     memberId:this.memberInfo.id,
        //     goodsList:this.gwList.map(v=>{
        //         return{
        //             goodsId:v.id,
        //             articleNo:v.articleNo,
        //             goodsPrice:v.finalPrice,
        //             isOriginal:v.isOriginal,
        //             quantity:v.num
        //         }
        //     })
        // })
        // let res = await TbGoods.GetTbGoodsByBarCode({barCode:'093321MQwJ',isShort:true});
        // let selectItem = res.getGoodsItemsList.filter(v=>v.shortBarCode=='093321MQwJ');
        // let indexArr = this.gwList.filter(j=>j.goodsItemId==selectItem[0].id);
        // let isGift = false;
        // if(indexArr.length==0){
        //     isGift = false;
        // }else if(indexArr.length==1){
        //     isGift = indexArr[0].isGift
        // }else if(indexArr.length==2){
        //     isGift = false
        // }
        // let obj = Object.assign({},res,{addGoodsItemsList:selectItem},{num:1,isGift:isGift,isEdit:false,isScan:true});
        // this.addProduct(obj);

        let defaultArr=this.gwList;
        let gwList = localStorage.getItem("gwByCoupon")?JSON.parse(localStorage.getItem("gwByCoupon")):defaultArr;
        gwList = gwList.map(v=>{
            return{
                goodsId:v.id,
                articleNo:v.articleNo,
                goodsPrice:v.finalPrice,
                isOriginal:v.isOriginal,
                quantity:v.num
            }
        })
        // console.log('gwList',gwList);

    }


    /**提示弹窗 */
    async tipConfirm(){
       switch (this.tipType) {
        /**清空商品 */
        case 1:
            this.showType = 1;
            this.gwList=[];
            localStorage.removeItem("gwByCoupon");
            localStorage.removeItem("receivablesByCoupon");
            localStorage.removeItem("orderRemark");
            this.resetSdObj();
            this.gwListByCalc = [];
            this.editIndex = null;
            this.editForm = {};
            break;
        /**购物车为空时，挂单提醒 */
        case 2:
            break;
        /**暂无挂单商品提醒 */
        case 3:
            break;
        /**请在购物车添加商品 */
        case 4:
            break;
        /**商品已下架 */
        case 5:
            break;
        /**无库存商品 */
        case 6:
            break;
        /**返回主页 */
        case 7:
            this.$router.push("/pad/mainPage/index");
            break;
        /**长按删除提醒 */
        case 8:
            this.deleteRow();
            break;
        /**请添加商品数量 */
        case 9:
            break;
        /**购物车里已有商品，无法取单 */
        case 10:
            break;
        /**挂单 */
        case 11:
            this.registrationFun();
            break;
        /**异常商品 */
        case 12:
            break;
        /**扫码-商品不存在或已删除 */
        case 13:
            break;
        /**扫码-商品已下架 */
        case 14:
        this.addProduct(this.scanItem);
            break;
        /**扫码-无库存 */
        case 15:
        this.addProduct(this.scanItem);
            break;
        case 16:
            break;
        /**赠送 */
        case 17:
            this.changeGift(true);
            break;
        /**取消赠送 */
        case 18:
            this.changeGift(false);
            break;

        default:
            break;
       }
        this.tipShow = false;
    }
    tipCancel(){
        this.tipShow = false;
    }
    /**挂单 */
    async registrationFun(){
        let obj = {
            memberInfo:this.memberInfo,
            list:this.gwList,
            createTime:dayjs().format("YYYY-MM-DD HH:mm:ss"),
            num:this.numTotal,
            total:this.priceTotal,
            remark:localStorage.getItem('orderRemark')?localStorage.getItem('orderRemark'):''
        }
        let historyGdList = localStorage.getItem("historyGdList")?JSON.parse(localStorage.getItem("historyGdList")):[];
        historyGdList.unshift(obj);
        let listLength = historyGdList.map(v=>v.list.length);
          let listNum = 0;
          if(listLength.length>0){
            listNum= listLength.reduce((a,b)=>calculate.addition(a,b))
          }
          if(Number(listNum)>1000){
            Toast('挂单商品总数不能超过1000')
            return;
          }
        localStorage.setItem("historyGdList",JSON.stringify(historyGdList));
        location.reload();
    }

    /**单个删除 */
    deleteRow(){
        this.gwList.splice(this.deleteIndex,1);
    }

    /**清空商品 */
    clearProduct(){
        if(this.isChanging) return;
        this.tipTitle = "操作提醒";
        this.tipText = `确认清空购物车吗？`;
        this.btnNums=2;
        this.confirmText = "确认";
        this.cancelText = "取消"
        this.tipType = 1;
        this.tipShow = true;
    }

    /**获取系统配置 */
    async getSetting(){
        let res = await TbSettingsPad.GetTbSettings({settingtype:2});
        this.settingContent = res.settingContent;
        this.isZeroStock = res.settingContent.isZeroStock;
    }

    /**挂单 */
    gdFun(){
        if(this.isChanging) return;
        if(this.gwList.length==0){
            this.tipTitle = "操作提醒";
            this.tipText = `购物车里暂无商品，无需挂单`;
            this.btnNums=1;
            this.confirmText = "确认";
            this.cancelText = ""
            this.tipType = 2;
            this.tipShow = true;
            return;
        }
        this.tipTitle = "操作提醒";
        this.tipText = `确定挂单？`;
        this.btnNums=2;
        this.confirmText = "确认";
        this.cancelText = "取消"
        this.tipType = 11;
        this.tipShow = true;
    }
    /**取单 */
    qdFun(){
        if(this.isChanging) return;
        this.historyGdList = localStorage.getItem("historyGdList")?JSON.parse(localStorage.getItem("historyGdList")):[];

        if(this.gwList.length>0){
            this.tipTitle = "操作提醒";
            this.tipText = `购物车里已有商品，无法取单`;
            this.btnNums=1;
            this.confirmText = "确认";
            this.cancelText = ""
            this.tipType = 10;
            this.tipShow = true;
            return;
        }
        if(this.historyGdList.length==0){
            this.tipTitle = "操作提醒";
            this.tipText = `暂无挂单商品`;
            this.btnNums=1;
            this.confirmText = "确认";
            this.cancelText = ""
            this.tipType = 3;
            this.tipShow = true;
            return;
        }

        this.isQd = true;
    }
    /**结算 */
    async settleFun(){
        if(this.gwList.some(v=>v.qdFail)){
            this.tipTitle = "操作提醒";
            this.tipText = `请先处理购物车里的异常商品！`;
            this.btnNums=1;
            this.confirmText = "确认";
            this.cancelText = ""
            this.tipType = 12;
            this.tipShow = true;
            return;
        }
        if(this.gwList.length==0){
            this.tipTitle = "操作提醒";
            this.tipText = `请在购物车添加商品`;
            this.btnNums=1;
            this.confirmText = "确认";
            this.cancelText = ""
            this.tipType = 4;
            this.tipShow = true;
            return;
        }
        await this.calcGwList();
        this.$nextTick(()=>{
            this.showType = 3;
            document.removeEventListener('keydown',this.handleScanCode) //离开当前路由，会直接调用beforeDestroy方法销毁回车事件
            document.removeEventListener('click', this.chargeInputFocus)
        })
    }
    /**选择商品 */
    async chooseProduct(item){
        if(this.gwList.some(v=>v.qdFail)){
            this.tipTitle = "操作提醒";
            this.tipText = `请先处理购物车里的异常商品！`;
            this.btnNums=1;
            this.confirmText = "确认";
            this.cancelText = ""
            this.tipType = 12;
            this.tipShow = true;
            return;
        }
        if(!item.isShelves){
            this.tipTitle = "商品已下架";
            this.tipText = `该商品已下架，无法添加至购物车中！`;
            this.btnNums=1;
            this.confirmText = "确认";
            this.cancelText = ""
            this.tipType = 5;
            this.tipShow = true;
            return;
        }
        if(!this.isZeroStock&&item.totalStock<=0){
            this.tipTitle = "无库存商品";
            this.tipText = `该商品无库存，无法添加至购物车中！`;
            this.btnNums=1;
            this.confirmText = "确认";
            this.cancelText = ""
            this.tipType = 6;
            this.tipShow = true;
            return;
        }
        this.$refs['productDetail'].showFun(item.id)
    }
    clickCount:number = 0;
    timer:any = null
    /**商品详情 */
    showDetail(item,index){
        this.editIndex = index;
        this.clickCount++
        this.timer = setTimeout( async ()=>{
            if(this.clickCount == 1){
                this.clickCount = 0
                if(item.isNoCode){
                    this.nocodeShow = true;
                    this.$nextTick(()=>{
                        this.$refs["noCodeProduct"].init({
                            sellingPrice:item.finalPrice,
                            num:item.num,
                        })
                    })
                }else{
                    this.$refs['leftProductDetail'].showDetailFun(item,index)
                }
            }else if(this.clickCount>1){
                this.clickCount = 0
                await this.touchstart(item,index)
                setTimeout( async ()=>{
                    await this.touchend()
                },200)
            }
        },300)

    }
    chooseDetail(item,index){
        if(this.isChanging) return;
        this.editIndex = index;
        this.clickCount++
        this.timer = setTimeout( async ()=>{
            if(this.clickCount == 1){
                this.clickCount = 0
                this.editIndex = index;
                this.editForm = item;
            }else if(this.clickCount>1){
                this.clickCount = 0
                await this.touchstart(item,index)
                setTimeout( async ()=>{
                    await this.touchend()
                },200)
            }
        },300)
    }
    /**单个商品添加购物车 */
    async addProduct(res){
        let mulChangePriceSet = localStorage.getItem('mulChangePricegSet')?JSON.parse(localStorage.getItem('mulChangePricegSet')):null;
        let memberDiscount =mulChangePriceSet? this.getMulMemberDiscount(mulChangePriceSet.memberDiscountVal,res):res.isMemberDiscount?this.memberInfo.id?this.memberInfo.gradeDiscount==0&&!this.memberInfo.gradeId?1:calculate.division(this.memberInfo.gradeDiscount,10):1:1;
        let index = null;
        index = this.gwList.findIndex(j=>j.goodsItemId==res.addGoodsItemsList[0].id&&(j.isGift==res.isGift));
        console.log('index',index,res);

        if(index>-1&&!res.isNoCode){
            let form = this.gwList[index];
            this.gwList.splice(index,1);
            this.gwList.unshift(Object.assign({},form,{num:calculate.addition(res.num,form.num),isGift:res.isGift}))
        }else{
            let discountPrice = mulChangePriceSet?this.getMulDiscountPrice(mulChangePriceSet,res):res.discountPrice;
            let finalPrice=res.isNoCode?res.sellingPrice:discountPrice?calculate.multiplication(discountPrice,memberDiscount): calculate.multiplication(res.sellingPrice,memberDiscount)
            this.gwList.unshift({
                ...res,
                isChangePrice:res.isGift||res.isNoCode?false:mulChangePriceSet?true:false,
                finalPrice:res.isGift?0:finalPrice,
                rate:res.isGift?0: res.isNoCode?100: finalPrice?calculate.multiplication(calculate.division(calculate.subtraction(finalPrice,res.costPrice),finalPrice),100):0,
                goodsItemId:res.isNoCode?null:res.addGoodsItemsList[0].id,
                num:res.num,
                isGift:res.isGift,
                discountPriceOld:res.discountPrice,
                discountPrice:discountPrice,
                goodDiscount:mulChangePriceSet?this.getMulGoodDiscount(mulChangePriceSet,res):res.goodDiscount,
                goodDiscountOld:res.goodDiscount,
                showPrice_DiscountPrice:finalPrice,
                showPrice_DiscountPriceOld:finalPrice,
                isDiscount:mulChangePriceSet?mulChangePriceSet.discountVal==2?true:mulChangePriceSet.discountVal==1?false:res.isDiscount:res.isDiscount,
                isDiscountOld:res.isDiscount,
                isIntegral:mulChangePriceSet?mulChangePriceSet.integralVal==2?true:mulChangePriceSet.integralVal==1?false:res.isIntegral:res.isIntegral,
                isIntegralOld:res.isIntegral,
                isMemberDiscount:mulChangePriceSet?mulChangePriceSet.memberDiscountVal==2?true:mulChangePriceSet.memberDiscountVal==1?false:res.isMemberDiscount:res.isMemberDiscount,
                isMemberDiscountOld:res.isMemberDiscount
            })
        }
        console.log('gw',this.gwList);
        await this.updateEditForm();
    }
    /**编辑购物车 */
    editProduct(res){
        console.log('editProduct',res);
        let memberDiscount = res.isMemberDiscount?this.memberInfo.id?this.memberInfo.gradeDiscount==0&&!this.memberInfo.gradeId?1:calculate.division(this.memberInfo.gradeDiscount,10):1:1;
        this.gwList.splice(this.editIndex,1);
        let finalPrice=res.isNoCode?res.sellingPrice:res.discountPrice?calculate.multiplication(res.discountPrice,memberDiscount): calculate.multiplication(res.sellingPrice,memberDiscount)
        let form = {
            ...res,
            finalPrice:res.isGift?0:finalPrice,
            rate:res.isGift?0: res.isNoCode?100: finalPrice?calculate.multiplication(calculate.division(calculate.subtraction(finalPrice,res.costPrice),finalPrice),100):0,
            goodsItemId:res.isNoCode?null:res.addGoodsItemsList[0].id,
            num:res.num,
            isGift:res.isGift,
        }
        /**是否赠品改变，涉及合并 */
        let index = this.gwList.findIndex(v=>v.goodsItemId==form.goodsItemId&&v.isGift==form.isGift&&!form.isNoCode);
        if(index>-1){
            let newFinalPrice = form.isGift?0:this.gwList[index].finalPrice;
            this.gwList[index].finalPrice = newFinalPrice;
            this.gwList[index].num = calculate.addition(this.gwList[index].num,form.num);
            this.gwList[index].rate = form.isGift?0: form.isNoCode?100: newFinalPrice?calculate.multiplication(calculate.division(calculate.subtraction(newFinalPrice,form.costPrice),newFinalPrice),100):0;
            this.$forceUpdate();
            this.updateEditForm();
        }else{
            this.gwList.unshift(form);
            this.updateEditForm();
        }

    }
    /**批量改价 */
    mulChangePricegFun(){
        let mulChangePriceSet = JSON.parse(localStorage.getItem('mulChangePricegSet'));
        // let memberDiscount = res.isMemberDiscount?this.memberInfo.id?this.memberInfo.gradeDiscount==0&&!this.memberInfo.gradeId?1:calculate.division(this.memberInfo.gradeDiscount,10):1:1;

        this.gwList = this.gwList.map(v=>{
            let memberDiscount = this.getMulMemberDiscount(mulChangePriceSet.memberDiscountVal,v);
            let discountPrice = this.getMulDiscountPrice(mulChangePriceSet,v);
            console.log('discountPrice',discountPrice);

            let finalPrice=v.isNoCode?v.sellingPrice:discountPrice?calculate.multiplication(discountPrice,memberDiscount): calculate.multiplication(v.sellingPrice,memberDiscount)
            return{
                ...v,
                isChangePrice:v.isGift||v.isNoCode?false:true,
                finalPrice:v.isGift?0:finalPrice,
                rate:v.isGift?0: v.isNoCode?100: finalPrice?calculate.multiplication(calculate.division(calculate.subtraction(finalPrice,v.costPrice),finalPrice),100):0,
                discountPriceOld:v.isNoCode?0:v.isChangePrice?v.discountPriceOld:v.discountPrice,
                discountPrice:v.isNoCode?0:discountPrice,
                goodDiscount:v.isNoCode?0:this.getMulGoodDiscount(mulChangePriceSet,v),
                goodDiscountOld:v.isNoCode?0:v.isChangePrice?v.goodDiscountOld:v.goodDiscount,
                showPrice_DiscountPrice:finalPrice,
                showPrice_DiscountPriceOld:v.isChangePrice?v.showPrice_DiscountPriceOld:finalPrice,
                isDiscount:v.isNoCode?false:mulChangePriceSet.discountVal==2?true:mulChangePriceSet.discountVal==1?false:v.isChangePrice?v.isDiscountOld:v.isDiscount,
                isDiscountOld:v.isNoCode?false:v.isChangePrice?v.isDiscountOld:v.isDiscount,
                isIntegral:v.isNoCode?false:mulChangePriceSet.integralVal==2?true:mulChangePriceSet.integralVal==1?false:v.isChangePrice?v.isIntegralOld:v.isIntegral,
                isIntegralOld:v.isNoCode?false:v.isChangePrice?v.isIntegralOld:v.isIntegral,
                isMemberDiscount:v.isNoCode?false:mulChangePriceSet.memberDiscountVal==2?true:mulChangePriceSet.memberDiscountVal==1?false:v.isChangePrice?v.isMemberDiscountOld:v.isMemberDiscount,
                isMemberDiscountOld:v.isNoCode?false:v.isChangePrice?v.isMemberDiscountOld:v.isMemberDiscount
            }
        })
        this.$forceUpdate();
        this.updateEditForm();
        console.log('gwList',this.gwList);

    }
    getMulMemberDiscount(set,item){
        let memberDiscount = 1;
        switch (set) {
            case null:
                let isMemberDiscount = item.isChangePrice?item.isMemberDiscountOld:item.isMemberDiscount;
                memberDiscount = isMemberDiscount?this.memberInfo.id?this.memberInfo.gradeDiscount==0&&!this.memberInfo.gradeId?1:calculate.division(this.memberInfo.gradeDiscount,10):1:1;
                break;
            case 1:
                memberDiscount = 1;
                break;
            case 2:
                memberDiscount = this.memberInfo.id?this.memberInfo.gradeDiscount==0&&!this.memberInfo.gradeId?1:calculate.division(this.memberInfo.gradeDiscount,10):1;
                break;

            default:
                break;
        }
        return memberDiscount;
    }
    getMulDiscountPrice(set,item){
        let val = 0;
        switch (set.goodDiscountVal) {
            case null:
                val = item.isChangePrice?item.discountPriceOld:item.discountPrice;
                break;
            case 1:
                val = item.sellingPrice;
                break;
            case 2:
                val = calculate.multiplication(item.sellingPrice,(calculate.multiplication(set.goodDiscount,0.1)));
                break;

            default:
                break;
        }
        return val;
    }
    getMulGoodDiscount(set,item){
        let val = 0;
        switch (set.goodDiscountVal) {
            case null:
                val = item.isChangePrice?item.goodDiscountOld:item.goodDiscount;
                break;
            case 1:
                val = 0;
                break;
            case 2:
                val = set.goodDiscount;
                break;

            default:
                break;
        }
        return val;
    }
    /**计算无码商品id */
    getGoodId(){
        let val = "";
        let arr = this.gwList.filter(v=>v.isNoCode).map(v=>v.id).sort((a,b)=>b-a);
        // console.log('arr',arr);

        val = arr.length>0 ? (calculate.addition(Number(arr[0]),1)).toString():"1";
        // console.log('val',val);

        return val
    }
    /**计算商品实际售价 */
    getFinalPrice(item){
        let val = 0;
        val = calculate.multiplication(item.finalPrice,item.num);
        return val;
    }
    /**计算商品实际售价 */
    getOriginPrice(item){
        let val = 0;
        val = calculate.multiplication(item.sellingPrice,item.num);
        return val;
    }
    getOriginPriceCalc(item){
        let val = 0;
        let memberDiscount = item.isMemberDiscount?this.memberInfo.id?this.memberInfo.gradeDiscount==0&&!this.memberInfo.gradeId?1:calculate.division(this.memberInfo.gradeDiscount,10):1:1;
        if(item.finalPrice!=item.originFinalPrice){
            val = item.discountPrice? calculate.multiplication(calculate.multiplication(item.discountPrice,memberDiscount),item.num):calculate.multiplication(calculate.multiplication(item.sellingPrice,memberDiscount),item.num);
        }else{
            val = calculate.multiplication(item.sellingPrice,item.num);
        }
        return val;
    }
    getOriginSinglePriceCalc(item){
        let val = 0;
        let memberDiscount = item.isMemberDiscount?this.memberInfo.id?this.memberInfo.gradeDiscount==0&&!this.memberInfo.gradeId?1:calculate.division(this.memberInfo.gradeDiscount,10):1:1;
        if(item.finalPrice!=item.originFinalPrice){
            val = item.discountPrice? calculate.multiplication(item.discountPrice,memberDiscount):calculate.multiplication(item.sellingPrice,memberDiscount);
        }else{
            val = item.sellingPrice;
        }
        return val;
    }
    /**计算折扣 */
    getDiscount(item){
        let val = 0;
        if(item.goodDiscount){
            val = item.goodDiscount;
        }else{
            if(item.discountPrice&&item.sellingPrice){
                val = calculate.division(item.discountPrice,item.sellingPrice,2,true);
                val = calculate.multiplication(val,10,2,true);
            }
        }
        return val;
    }
    /**计算优惠 */
    getYh(item){
        let val = 0;
        let oVal = this.getOriginPrice(item);
        let dVal = this.getFinalPrice(item);
        val = calculate.subtraction(oVal,dVal)
        return val;
    }
    getYh2(item){
        let val = 0;
        let oVal = this.getOriginPriceCalc(item);
        let dVal = item.finalPrice;
        val = calculate.subtraction(oVal,dVal);
        return val;
    }
    /**返回主页 */
    goBackHome(){
        if(this.gwList.length>0){
            this.tipTitle = "操作提醒";
            this.tipText = `购物车里还有商品，确定返回吗？`;
            this.btnNums=2;
            this.confirmText = "确认";
            this.cancelText = "取消"
            this.tipType = 7;
            this.tipShow = true;
        }else{
            this.$router.push("/pad/mainPage/index");
        }
    }
    clickCountNew:number = 0;
    async DelVip(item){
        this.clickCountNew++
        setTimeout( async ()=>{
            if(this.clickCountNew == 1){
                this.clickCountNew = 0;
                this.showVipList();
            }else if(this.clickCountNew>1){
                this.clickCountNew = 0
                await this.vipTouchstart(item,null)
                setTimeout( async ()=>{
                    await this.touchend()
                },200)
            }
        },300)

    }

    /**会员长按删除 */
    vipTouchstart(item,index){
        if(this.showType==3) return;
        if(this.isChanging) return;
        clearInterval(this.Loop); //再次清空定时器，防止重复注册定时器
        this.Loop = setTimeout(function() {
            this.memberInfo = {};
            this.calcGwListBySelf();
        }.bind(this), 200);//手指或者鼠标按下等待的时间
    }
    /**购物车长按删除 */
    touchstart(item,index){
        if(this.showType==3) return;
        if(this.isChanging) return;
        clearInterval(this.Loop); //再次清空定时器，防止重复注册定时器
        this.Loop = setTimeout(function() {
            this.tipTitle = "操作提醒";
            this.tipText = `确认将该商品从购物车里删除吗？`;
            this.btnNums=2;
            this.confirmText = "确认";
            this.cancelText = "取消"
            this.tipType = 8;
            this.deleteIndex = index;
            this.tipShow = true;
        }.bind(this), 200);//手指或者鼠标按下等待的时间
    }
    touchend(){
        console.log('touchend');

        if(this.showType==3) return;
        clearInterval(this.Loop);
    }
    tipFun(){
        this.tipTitle = "操作提醒";
        this.tipText = `请添加商品数量`;
        this.btnNums=1;
        this.confirmText = "确认";
        this.cancelText = ""
        this.tipType = 9;
        this.tipShow = true;
    }
    showVipList(){
        if(this.showType==3) return;
        if(this.isChanging) return;
        this.showType = this.showType==1?2:1;
    }
    /**选择会员 */
    chooseMember(item){
        this.memberInfo = item;
        this.showType = 1;
        this.calcGwListBySelf();
    }
    /**计算购物车全部商品-自己算 */
    calcGwListBySelf(){
        if(this.gwList.length==0) return;
        let memberDiscount = this.memberInfo.id?this.memberInfo.gradeDiscount==0&&!this.memberInfo.gradeId?1:calculate.division(this.memberInfo.gradeDiscount,10):1;
        this.gwList = this.gwList.map(v=>{
            let newMemberDiscount = v.isMemberDiscount?memberDiscount:1
            let finalPrice=v.isGift?0: v.isNoCode?v.sellingPrice:v.discountPrice?calculate.multiplication(v.discountPrice,newMemberDiscount): calculate.multiplication(v.sellingPrice,newMemberDiscount)
            return {
                ...v,
                finalPrice:finalPrice,
                rate:v.isGift?0:finalPrice?calculate.multiplication(calculate.division(calculate.subtraction(finalPrice,v.costPrice),finalPrice),100):0,
            }
        })
    }
    /**计算购物车全部商品-后台算 */
    async calcGwList(isDefault=true){
        if(this.gwList.length==0) return;
        let wholeOrderDiscountPrice = 0;
        let memberDiscount = this.memberInfo.id?this.memberInfo.gradeDiscount==0&&!this.memberInfo.gradeId?1:calculate.division(this.memberInfo.gradeDiscount,10):1;
        let arr = this.gwList.map(v=>v.isGift?0:v.isNoCode?calculate.multiplication(v.sellingPrice,v.num):v.discountPrice? calculate.multiplication(calculate.multiplication(v.discountPrice,v.isMemberDiscount?memberDiscount:1),v.num): calculate.multiplication(calculate.multiplication(v.sellingPrice,v.isMemberDiscount?memberDiscount:1),v.num));
        console.log('arr',arr,this.gwList);


        if(arr.length>0){
            wholeOrderDiscountPrice = arr.reduce((a,b)=>calculate.addition(a,b));
        }

        let obj = {
            shopId:this.userInfo.shopId,
            memberCouponId:this.sdObj.memberCouponId,
            isSingle:this.sdObj.isSingle,
            memberId:this.memberInfo.id?this.memberInfo.id:"",
            isWholeOrderDiscount:this.sdObj.isWholeOrderDiscount,
            wholeOrderDiscountPrice:isDefault?wholeOrderDiscountPrice:this.sdObj.wholeOrderDiscountPrice,
            orderDiscount:this.sdObj.orderDiscount,
            isDeduction:this.sdObj.isDeduction,
            useIntegral:this.sdObj.useIntegral,
            pointDeduction:this.sdObj.pointDeduction,
            items:this.gwList.map(v=>{
                return{
                    shopId:v.shopId,
                    goodId:v.id,
                    goodsItemId:v.goodsItemId,
                    num:v.num,
                    articleNo:v.articleNo,
                    price:v.isNoCode?v.sellingPrice:0,
                    isGift:v.isGift,
                    giftNum:v.isGift?v.num:0,
                    isChangePrice:v.isChangePrice?v.isChangePrice:false,
                    discountPrice:v.discountPrice,
                    goodDiscount:v.goodDiscount,
                    isDiscount:v.isDiscount,
                    isMemberDiscount:v.isMemberDiscount,
                    isIntegral:v.isIntegral,
                    showPrice_DiscountPrice:v.discountPrice,
                }
            })
        }
        let resOrder = await TbOrderPad.CalcOrderInfo(obj);
        this.calcOrderInfo = resOrder;
        this.gwListByCalc = this.gwList.map(v=>{
            let item = v.isNoCode?resOrder.items.find(j=>j.goodId==v.id): resOrder.items.find(j=>j.goodsItemId==v.goodsItemId);
            return {
                ...v,
                originFinalPrice:v.isGift?0:calculate.multiplication(v.finalPrice,v.num),
                finalPrice:v.isGift?0:item.finalPrice,
                rate:v.isGift?0:item.rate,
                isOriginal:item.isOriginal,
                isCoupon:item.isCoupon,
                isGift:v.isGift
            }
        })

    }
    calcFun(sdObj){
        this.sdObj = sdObj;
        this.calcGwList(false);
    }
    async calcCoupon(sdObj){
        if(this.gwList.length==0) return;
        let wholeOrderDiscountPrice = 0;
        let memberDiscount = this.memberInfo.id?this.memberInfo.gradeDiscount==0&&!this.memberInfo.gradeId?1:calculate.division(this.memberInfo.gradeDiscount,10):1;
        let arr = this.gwList.map(v=>v.isGift?0:v.isNoCode?calculate.multiplication(v.sellingPrice,v.num):v.discountPrice? calculate.multiplication(calculate.multiplication(v.discountPrice,v.isMemberDiscount?memberDiscount:1),v.num): calculate.multiplication(calculate.multiplication(v.sellingPrice,v.isMemberDiscount?memberDiscount:1),v.num));


        if(arr.length>0){
            wholeOrderDiscountPrice = arr.reduce((a,b)=>calculate.addition(a,b));
        }

        let obj = {
            shopId:this.userInfo.shopId,
            memberCouponId:sdObj.memberCouponId,
            isSingle:sdObj.isSingle,
            memberId:this.memberInfo.id?this.memberInfo.id:"",
            isWholeOrderDiscount:sdObj.isWholeOrderDiscount,
            wholeOrderDiscountPrice:sdObj.wholeOrderDiscountPrice,
            orderDiscount:sdObj.orderDiscount,
            isDeduction:sdObj.isDeduction,
            useIntegral:sdObj.useIntegral,
            pointDeduction:sdObj.pointDeduction,
            items:this.gwList.map(v=>{
                return{
                    shopId:v.shopId,
                    goodId:v.id,
                    goodsItemId:v.goodsItemId,
                    num:v.num,
                    articleNo:v.articleNo,
                    price:v.isNoCode?v.sellingPrice:0,
                    isGift:v.isGift,
                    giftNum:v.isGift?v.num:0,
                    isChangePrice:v.isChangePrice?v.isChangePrice:false,
                    discountPrice:v.discountPrice,
                    goodDiscount:v.goodDiscount,
                    isDiscount:v.isDiscount,
                    isMemberDiscount:v.isMemberDiscount,
                    isIntegral:v.isIntegral,
                    showPrice_DiscountPrice:v.discountPrice,
                }
            })
        }
        let resOrder = await TbOrderPad.CalcOrderInfo(obj);
        Bus.$emit('resCalcCoupon',resOrder)
    }
    /**无码商品 */
    closeNocode(){
        this.nocodeShow = false;
    }
    addNoCode(form){
        let id = this.getGoodId();
        let obj = {
            name:"无码商品",
            isNoCode:true,
            sellingPrice:form.sellingPrice,
            costPrice:form.sellingPrice,
            num:form.num,
            shopId:this.userInfo.shopId,
            id:id,
            articleNo:"",
            isGift:false,
            addGoodsItemsList:[{
                shopId:this.userInfo.shopId,
                goodsId:id,
                id:null,
                num:1,
                articleNo:"",
                giftNum:0,
                isGift:false,
            }]
        }

        this.addProduct(obj)
    }
    editNoCode(val){
        let form = this.gwList[this.editIndex];
        let obj = Object.assign({},form,{
            sellingPrice:val.sellingPrice,
            costPrice:val.sellingPrice,
            num:val.num,
        })
        // console.log(obj);

        // this.gwList.splice(this.editIndex,1);
        // this.gwList.unshift(obj);
        this.editProduct(obj)
    }

    showNoCode(){
        this.nocodeShow = true;
    }

    /**结算页返回 */
    goBack(){
        localStorage.removeItem("gwByCoupon");
        localStorage.removeItem("receivablesByCoupon");
        this.resetSdObj();
        this.showType=1;
        this.gwListByCalc = [];
        this.getInputFocus()

    }
    resetSdObj(){
        this.sdObj = {
            memberCouponId:"",
            isSingle:false,
            isWholeOrderDiscount:false,
            wholeOrderDiscountPrice:0,
            orderDiscount:0,
            isDeduction:false,
            useIntegral:0,
            pointDeduction:0,
        }
    }
    /**清空挂单 */
    clearGd(){
        this.historyGdList = [];
        localStorage.removeItem("historyGdList");
        this.qdBack();
    }
    /**挂单返回 */
    qdBack(){
        this.isQd = false;
    }
    /**取单 */
    async chooseQd(v,index){
        if(v.memberInfo.id){
            this.memberInfo = v.memberInfo;
        }else{
            this.memberInfo = {};
        }
        let newList =[];
        let ids = v.list.map(v=>v.id);

        let res = await TbGoods.PostGoodsItemsByIds({ids:ids});
        for(let i=0;i<v.list.length;i++){
            if(v.list[i].isNoCode){
                newList.push(v.list[i])
            }else{
               let goodItem = res.find(vv=>vv.goodsId==v.list[i].id)
                let stock = goodItem.items.findIndex(j=>j.goodsItemId==v.list[i].addGoodsItemsList[0].id)>-1?goodItem.items.find(j=>j.goodsItemId==v.list[i].addGoodsItemsList[0].id).stock:0
                let noStock = calculate.subtraction(stock,v.list[i].num);

                newList.push(Object.assign({},v.list[i],
                {
                    isDelete:goodItem.isDelete,
                    isShelves:goodItem.isShelves,
                    qdFail:goodItem.isDelete||!goodItem.isShelves||(!this.isZeroStock&&noStock<0),
                    syStock:noStock,
                    noStock:stock
                }
                ))

            }
        }
        // console.log('v.list',newList);

        this.gwList = newList;
        // console.log('chooseQd',this.gwList);
        if(v.remark){
            localStorage.setItem('orderRemark',v.remark);
        }

        this.isQd = false;
        let arr = this.historyGdList;
        arr.splice(index,1);
        localStorage.setItem("historyGdList",JSON.stringify(arr));
    }
    addRemark(){
        this.$refs['remarkPanel'].showFun();
    }
    /**改价 */
    changePrice(){
        if(this.editIndex===null||this.editIndex===''){
            Toast("请先在购物中选择商品！");
            return;
        }
        if(!this.hasAuth('602')){
            Toast("暂无改价权限！")
            return;
        }
        if(this.editForm.isGift) return;
        if(this.editForm.isNoCode){
            this.nocodeShow = true;
            this.$nextTick(()=>{
                this.$refs["noCodeProduct"].init({
                    sellingPrice:this.editForm.finalPrice,
                    num:this.editForm.num,
                })
            })
            return;
        };
        this.$refs['changePricePanel'].showFun();
    }
    /**判断权限 */
    hasAuth(auth) {
        let val = false;
        let btnPermissionsStr = this.userInfo['authorityJson'].split(',');
        if (btnPermissionsStr == undefined || btnPermissionsStr == null) {
        val = false;
        }
        if (btnPermissionsStr.some(v=>v==auth)) {
        val = true;
        }
        return val;
    }
    /**赠送 */
    giftFun(){
        if(this.editIndex===null||this.editIndex===''){
            Toast("请先在购物中选择商品！");
            return;
        }
        if(this.editForm.isNoCode) return;
        if(!this.editForm.isGift){
            this.tipTitle = "赠送";
            this.tipText = `确定赠送该商品吗？`;
            this.btnNums=2;
            this.confirmText = "确定赠送";
            this.cancelText = "关闭"
            this.tipType = 17;
            this.tipShow = true;
        }else{
            this.tipTitle = "取消赠送";
            this.tipText = `确定取消赠送该商品吗？`;
            this.btnNums=2;
            this.confirmText = "取消赠送";
            this.cancelText = "关闭"
            this.tipType = 18;
            this.tipShow = true;
        }
    }
    changeGift(val){
        let obj = Object.assign({},this.editForm,{isGift:val});
        this.editProduct(obj);
    }
    updateEditForm(){
        if(this.editIndex===null||this.editIndex===''){
            this.editForm = {};
        }else{
            this.editForm = this.gwList[this.editIndex];
        }
    }
    changeSpecANumFun(val){
        if(this.editIndex===null||this.editIndex===''){
            Toast("请先在购物中选择商品！");
            return;
        }
        if(this.editForm.isNoCode){
            if(val==2){
                this.nocodeShow = true;
                this.$nextTick(()=>{
                    this.$refs["noCodeProduct"].init({
                        sellingPrice:this.editForm.finalPrice,
                        num:this.editForm.num,
                    })
                })
            }
            return;
        }
        this.$refs['changeSpecANum'].showDetailFun(this.editForm,this.editIndex,val)
    }
    mulChangePrice(){
        if(!this.hasAuth('603')){
            Toast("暂无批量改价权限！")
            return;
        }
         if(this.mulChangeDisable) return;
        this.$refs['mulChangePricePanel'].showFun();
    }

}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/cashier/components/cashierOperate.vue